;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/IFrame',["jquery", "eventManager"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager")) :
    console && console.error('Iframe does not support non-amd script loading.');
}(this/* window */, function ($, eventManager) {

    function Iframe(scope) {
        ///<summary>Initialize a new instance of Iframe. Subscribe to messages which are passed to current instance.</summary>

        var self = this;
        Object.defineProperty(this, '$scope', { enumerable: true, value: $(scope) });


        var iframeComp = $('iframe', this.$scope);

        // #region calculate the size with 4:3 ratio
        if (!!iframeComp.length && iframeComp.data('autosize') !== 'disabled') {
            //var iframeHolder = iframeComp.parent();
            var width = this.calculateSize(); // iframeHolder.width();

            //This calculation will set the size to a 4:3 ratio.
            iframeComp.css({
                'height': (width / 1.25 | 0) + 'px', 
                'width': width + 'px'
            });
        }
        //#endregion
    }

    Iframe.prototype.calculateSize = function () {
        var tempProps = { /* 'position': 'absolute', */ 'display': 'block', 'visibility': 'hidden' };
        var $hiddenEls = $(this.$scope.parents().addBack().not(':visible').get());
        var savedProps = [];

        // make parents to be hidden, but allocate their size on a page.
        $hiddenEls.each(function () {
            var $this = $(this);
            // preserved props
            var pProps = {};
            for (var key in tempProps) {
                pProps[key] = this.style[key];
                $this.css(key, tempProps[key]);
            }

            savedProps.push(pProps);
        });

        // calculate the size
        var width = this.$scope.width();

        // revert css changes back, to the original
        $hiddenEls.each(function () {
            var $this = $(this);
            var props = savedProps.shift();
            for (var key in tempProps) {
                $this.css(key, props[key]);
            }
        });

        // return size
        return width;
    }

    Iframe.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new Iframe(args.scope);
    };

    return Iframe;
}));
